export const valid = require('./valid.png');
export const shield = require('./shield1.png');
export const graphic = require('./graphic.png');
export const noValid = require('./no-valid.png');
export const userLogo = require('./user-logo.png');
export const soccerBall = require('./soccer-ball.png');